import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";

const CategoryDropdown = () => {
  const [categories, setCategories] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          "https://mycobro.com/api/categories/all_stores"
        );
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        className="text-white bg-blue-600 px-4 py-2 rounded hover:bg-blue-700 transition-colors"
        onClick={() => setIsDropdownOpen((prev) => !prev)}
      >
        Collections
      </button>
      {isDropdownOpen && (
        <div className="absolute z-50 bg-white text-black mt-2 w-56 shadow-xl rounded-md border border-gray-200">
          <div className="p-2 border-b border-gray-200 pb-2">
            <h3 className="font-medium text-gray-700 text-sm">All Categories</h3>
          </div>
          <div className="max-h-64 overflow-y-auto">
            <ul className="py-1">
              {categories.map((category) => (
                <li key={category._id}>
                  <Link
                    to={`/${category.store.slug}/collections/${category.slug}`}
                    className="block px-4 py-2.5 hover:bg-gray-100 transition-colors text-sm text-gray-700"
                    onClick={() => setIsDropdownOpen(false)}
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryDropdown;